module.exports = __webpack_public_path__ + "a2f6bd2b35e88329745593f6842c815c.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/officehours-v2/routes/JoinPage/components/JoinSessionPage/images/companies/NYULangone_Logo.png
// module id = 1068
// module chunks = 0